import React from "react";
import PropTypes from "prop-types";

import { DEFAULT_LICENSE_DAYS } from "../../constants/averageRates";
import PricesBlock from "./PricesBlock";

const getDaysUnit = (count, t, language) => {
  if (language === "en") {
    return count === 1 ? t("trace-average-rates-days-one", "day") : t("trace-average-rates-days-many", "days");
  }

  const abs = Math.abs(count) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) {
    return t("trace-average-rates-days-many", "дней");
  }
  if (last === 1) {
    return t("trace-average-rates-days-one", "день");
  }
  if (last >= 2 && last <= 4) {
    return t("trace-average-rates-days-few", "дня");
  }
  return t("trace-average-rates-days-many", "дней");
};

const PaywallView = ({ averagePrice, minPrice, maxPrice, days, onPayClick, language, t }) => (
  <div className="averageRates averageRates--paywall">
    <div className="averageRates__title">{t("trace-average-rates-paywall-title", "Узнать среднюю ставку ATI.SU")}</div>
    <div className="averageRates__subtitle">
      {t("trace-average-rates-paywall-subtitle", "по этому и другим направлениям")}
    </div>
    <PricesBlock averagePrice={averagePrice} minPrice={minPrice} maxPrice={maxPrice} t={t} blurred />
    <button type="button" className="glz-button glz-is-primary glz-is-outlined glz-is-small" onClick={onPayClick}>
      {t("trace-average-rates-buy-for", "купить на {{days}} {{daysUnit}}", {
        days,
        daysUnit: getDaysUnit(days, t, language),
      })}
    </button>
  </div>
);

PaywallView.propTypes = {
  averagePrice: PropTypes.number,
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  days: PropTypes.number,
  onPayClick: PropTypes.func,
  language: PropTypes.string,
  t: PropTypes.func.isRequired,
};

PaywallView.defaultProps = {
  averagePrice: null,
  minPrice: null,
  maxPrice: null,
  days: DEFAULT_LICENSE_DAYS,
  onPayClick: () => {},
  language: "ru",
};

export default PaywallView;
